import { BgColors } from "@/utils/types";
import { sanitize } from "@/utils/sanitize";
import WavePattern from "../modules/WavePattern";

export interface DividerProps {
  backgroundColor?: BgColors;
  componentId?: string;
}

export const Divider = ({
  backgroundColor = "bg-white",
  componentId,
}: DividerProps) => {
  return (
    <section
      id={componentId}
      className={`divider w-full${
        backgroundColor
          ? ` ${sanitize(backgroundColor) === "pattern" ? "pattern bg-secondary" : sanitize(backgroundColor) === "waves" ? "waves bg-white" : sanitize(backgroundColor)}`
          : ""
      }`}
    >
      <div className="flex items-center justify-center w-full">
        <WavePattern
          waves={3}
          width="183px"
          thickness={5}
          color={
            sanitize(backgroundColor) === "bg-secondary" ? "#540389" : "#cac0fc"
          }
        />
      </div>
    </section>
  );
};
